export enum Region {
    US = 1,
    KR = 2,
    EU = 3,
    TW = 4,
}
